import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Headers, Http } from '@angular/http';
//import {Router,RouteParams}  from '@angular/router';
import {Album, Photo, Buyer } from './bean';
import {PhotoService} from './service.photo';
import { DecimalPipe } from '@angular/common/src/pipes';
import { CommonService} from './service.common';
//import './photoswipe/photoswipe.min.js';
//import './photoswipe/photoswipe-ui-default.min.js';
//declare var openPhotoSwipe: any;
//import './photoswipe/my.js';

@Component({
    selector: 'panel-result',
    templateUrl: './html/panelResult.html'
//	,styleUrls: ['./photoswipe/photoswipe.css','./photoswipe/default-skin/default-skin.css']
})

export class PanelResultComponent{
	
	private roundNumber(number, decimals): number {
		var newnumber = new Number(number+'').toFixed(parseInt(decimals));
		return parseFloat(newnumber); 
	}
	
	setView(view : number): void{
		this.photoService.setCurrentView(view);
	}
	//prefixCharFilters: Array<String>;
	setResultWithKeyword() :void {
		this.photoService.setCurrentKeyword();
		this.photoService.view = 2;
	}

	keyPressed(event: KeyboardEvent): void{
		if(event.code == 'Enter'){
			this.photoService.setCurrentKeyword();
			this.photoService.view = 2;
		}
	}

	//private right :boolean = true;
	private removeRightClick(event) : void{
		event.preventDefault()
	}
	private recoverRightClick(event): void{
		document.removeEventListener('contextmenu', this.removeRightClick);
		
	}

	constructor(
		//private contentService: ContentService,
		private photoService: PhotoService,
		private commonService: CommonService,
		private http: Http,
		private route: ActivatedRoute,
		private router: Router
		) {
////			this.photoService.setAlbums();
	}

	ngOnInit(){

	}
	myOpenPhotoSwipe(idx: number): void{
		this.commonService.myOpenPhotoSwipe(idx);
	}


/*
	changePrefix(prefix: string): void{
		this.bookService.setPrefix(prefix);
	}
	changeSeries(pubClass: PubClass){
////this.bookService.setPubClass(pubClass);
	}
	logout(): void {
		this.authService.logout();
		this.router.navigate(['/login']);
    }
	*/
}



// WEBPACK FOOTER //
// ./src/app/panelResult.ts